module.exports = {
    contentTypes:
      [
        {
          type: 'STREAM',
          name: 'Streams',
          description: 'Choose a layout that can categorise your Streams and group them in the most relevant way.',
        },
        {
          type: 'COLLECTION',
          name: 'Collections',
          description: 'Choose a layout that can showcase your pre-designed Collections in the best light.',
        }, 
        {
          type: 'ASSET',
          name: 'Assets',
          description: 'Choose a layout that can enable easy discovery of Assets on your Hub.',
        }
      ]
  };
  